import { useState } from "react";
import { FloppyDiskIcon, XIcon, UserCircleIcon } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";

const KEY = "alphaapeing_signin_reminder_dismissed";

export const SignInReminder = () => {
  const { isAuthed, openAuth } = useAuth();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(KEY) === "1");

  if (isAuthed || dismissed) return null;

  const close = () => {
    localStorage.setItem(KEY, "1");
    setDismissed(true);
  };

  return (
    <div data-testid="signin-reminder" className="flex items-center gap-3 border border-neon/30 bg-neon/[0.07] px-4 py-3">
      <FloppyDiskIcon size={22} weight="fill" className="text-neon shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-white">Save your wallets & Alpha devs</p>
        <p className="text-xs text-muted-foreground">Create a free account so your tracked wallets, creators and alerts sync across devices — and never reset again.</p>
      </div>
      <button data-testid="signin-reminder-cta" onClick={() => openAuth("signup", "", "save your wallets & creators")} className="flex items-center gap-1.5 px-4 py-2 bg-neon text-black font-semibold text-sm hover:bg-neon/90 transition-colors shrink-0">
        <UserCircleIcon size={16} weight="fill" /> Sign in
      </button>
      <button data-testid="signin-reminder-dismiss" onClick={close} title="Dismiss" className="p-1 text-muted-foreground hover:text-white shrink-0">
        <XIcon size={18} />
      </button>
    </div>
  );
};
